import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { NG_ASYNC_VALIDATORS, NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';

@Component({
  selector: 'app-radio-group',
  templateUrl: './radio-group.component.html',
  styleUrl: './radio-group.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioGroupComponent),
      multi: true
    }]
})
export class RadioGroupComponent implements AfterViewInit, AfterViewChecked {
  @Input() label!: string;
  @Input() name!: string;
  @Input() status!: string;
  @Input() options: { value: string; label: string }[] = [];
  @Input() model: string = '';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;

  @ViewChild('inputModel', { static: false }) inputModel!: NgModel;
  // @Output() modelChange = new EventEmitter<string>();
  
  constructor(private cdr: ChangeDetectorRef){}

  value: string = '';

  private onChangeCallback: any = () => {};

  ngAfterViewChecked() {
    if (this.inputModel && this.value !== this.inputModel.value) {
      // console.log(this.value, 'chaged');
      this.writeValue(this.value);
    }
  }
  
  ngAfterViewInit() {
    if (this.inputModel) {
      this.inputModel.control.setValue(this.value);
      this.cdr.detectChanges(); // Manually trigger change detection
    }
  }

  onChange(value: string) {
    this.value = value;
    // this.modelChange.emit(value);
    if (this.onChangeCallback) {
      this.onChangeCallback(value); // Call the registered callback (the parent component's binding)
    }
  }

  onTouched = () => { };

  writeValue(value: any): void {
    this.value = value;
    this.model = value;
    if(this.inputModel)
      this.inputModel.control.setValue(value);
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  markAsTouched(): void {
    if (this.inputModel) {
      this.inputModel.control.markAsTouched();
    }
  }
}
